module.exports = __webpack_public_path__ + "static/product-l0970-red-68467ebb1dfd32e3705ac6c6b21fb955.png";